/**
 * Checkbox GUI component
 */

import { Checkbox } from "@mantine/core";
import type { GuiCheckboxElement } from "../types";
import { useWebSocket } from "../WebSocket";
import { useViewerStore } from "../store";

interface GuiCheckboxProps {
  element: GuiCheckboxElement;
}

export function GuiCheckbox({ element }: GuiCheckboxProps) {
  const { sendGuiEvent } = useWebSocket();
  const updateGuiValue = useViewerStore((state) => state.updateGuiValue);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.currentTarget.checked;

    // Update local state
    updateGuiValue(element.uuid, value);

    // Send to Python backend
    sendGuiEvent(element.uuid, "change", value);
  };

  return (
    <Checkbox
      label={element.label}
      checked={element.value}
      onChange={handleChange}
      disabled={element.disabled}
      size="sm"
      style={{ marginBottom: "8px" }}
    />
  );
}
